// extracted by mini-css-extract-plugin
export default {"root":"FVSxr","large":"_2hp6p","medium":"fG7In","small":"_1vhEG","daily-deviation":"dmx2a","dailyDeviation":"dmx2a","hype":"_1JNh2","stash":"_2eegX"};